<template>
  <div class="step" :class="{ 'step_active': active }">
    <div class="step__inner">
      <h3 class="step__title">Информация о событии, имеющем признаки страхового случая</h3>
      <DateInput :required="true" @setError="errors.date = $event" name="event-date" text="Дата наступления события" :range="false" v-model="form.event.date" />
      <SelInput :required="true" text="Страховое событие" name="event-type" :options="eventtypes" v-model="form.event.type" />
      <SelInput :required="true" text="Причина страхового события" name="event-reason" :options="eventreasons" v-model="form.event.reason" />
      <TextAreaInput :maxlength="1000" :validation="(v) => (v.length > 1000) ? 'Не более 1000 символов': ''" @setError="errors.description = $event" v-model="form.event.description" text="Описание обстоятельств наступления события:" name="event-description" />
      <Btn class="step__next" :disabled="!filled" @click="$store.commit('nextStep')">Далее</Btn>
    </div>
  </div>
</template>

<script>
import Btn from '../Btn.vue';
import DateInput from '../inputs/DateInput.vue';
import SelInput from '../inputs/SelInput.vue';
import TextAreaInput from '../inputs/TextAreaInput.vue';
import { mapState } from 'vuex';

export default {
  components: { DateInput, SelInput, TextAreaInput, Btn },
  data: () => ({
    errors: {},
    eventtypes: ['', 'Смерть', 'Инвалидность I группы', 'Инвалидность II группы ', 'Инвалидность III группы '],
    eventreasons: ['', 'Болезнь', 'Несчастный случай']
  }),
  props: {
    active: { type: Boolean }
  },
  computed: {
    ...mapState(['form']),
    filled() {
      for (let key in this.errors)
        if (this.errors[key]) return false
      let required = ['date', 'type', 'reason']
      for (let key of required)
        if (!this.form.event[key]) return false
      return true
    }
  },
}
</script>

<style lang="sass">

</style>